import React, { useState, useEffect, useRef } from "react";
import { Form, Row, Col, message, Input, Button } from "antd";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { clock } from "../../utils/clock";
import { Scrollbars } from "react-custom-scrollbars";
import MenuIcon from "../../assets/images/icon.png";
import db from "../../database";
import data from "../../constants/opentillClosetill.json";
import "../style.css";
import "../Till/TillScreens.css";
import { EditOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { getMultilingualText } from "../../utils/getMultilingualText";
import { useTranslation } from "react-i18next";
import messages from "../../errors/messages.en-IN.json";
import useAuthStore from "../../stores/useAuthStore";
import usePOSConfigStore from "../../stores/usePOSConfigStore";
import useSessionStore from "../../stores/useSessionStore";
import { trace } from "../../utils/debugTrace";

const CloseTillAll = () => {
  const { t } = useTranslation();
  const multilingual = process.env.REACT_APP_MULTILINGUAL === "true" && localStorage.getItem("selectedLanguage") !== "English";
  const tillData = useAuthStore((s) => s.tillData);
  const tillSession = useSessionStore.getState().tillSession;
  const [allExpectedAmount, setAllExpectedAmount] = useState(0);
  const [allTransactionCount, setAllTransactionCount] = useState(0);
  const [paymentsList, setPaymentsList] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalOrdersCount, setTotalOrdersCount] = useState(0);
  const posConfig = usePOSConfigStore((s) => s.posConfig);

  const sessionId = tillSession?.tillSessionId;
  const [salesAmount, setSalesAmount] = useState(0);
  const [noteValue, setNoteValue] = useState("");
  const [editAmount, setEditAmount] = useState("");
  const [cashValues, setCashValues] = useState({
    cashIn: 0,
    cashOut: 0,
    pettyCashIn: 0,
    pettyCashOut: 0,
  });
  const tillId = tillData?.tillAccess?.cwrTill?.cwrTillID;
  const [hideBackButton, setHideBackButton] = useState(false);

  useEffect(() => {
    const checkTillEvents = async () => {
      const tillEvents = await db?.tillEvents.where("tillStatus").equals("open").toArray();
      if (tillEvents.length > 0) {
        const currentDate = dayjs().format("YYYY-MM-DD");
        const tillEventDate = tillEvents[0]?.openingTime?.split(" ")[0];
        if (currentDate !== tillEventDate) {
          setHideBackButton(true); // hide button
        }
      }
    };

    checkTillEvents();
  }, []);

  useEffect(() => {
    const fetchTillData = async () => {
      let obj = cashValues;
      let payments = [];
      try {
        if (!tillData || !tillSession) {
          history.push("/till");
          return;
        }

        if (tillSession?.cashInOutData) {
          setCashValues(tillSession.cashInOutData);
          obj = tillSession.cashInOutData;
        }

        if (Array.isArray(tillSession?.allPaymentsData)) {
          payments = (tillSession.allPaymentsData || []).map((payment) => {
            if (payment.name.toLowerCase() !== "cash" && (!payment.cwrTillId || payment.cwrTillId === tillId)) {
              return {
                ...payment,
                amount: payment.amount > 0 ? parseFloat(payment.amount.toFixed(2)) : parseFloat(payment.expectedAmount.toFixed(2)),
                actualAmount: payment.actualAmount > 0 ? parseFloat(payment.actualAmount.toFixed(2)) : parseFloat(payment.expectedAmount.toFixed(2)),
                difference: 0,
              };
            }
            return { ...payment };
          });
        } else {
          const allPaymentMethods = tillData?.tillAccess?.csBunit?.paymentMethodList || [];
          const paymentMethodList = allPaymentMethods.filter((p) => !p.cwrTillId || p.cwrTillId === tillId);
          const orders = await db.orders.where("tillSessionId").equals(sessionId).toArray();
          const tillEvent = await db.tillEvents.where("tillSessionId").equals(sessionId).toArray();

          if (tillEvent.length > 0 && tillEvent[0]?.cashInOutData) {
            setCashValues(tillEvent[0].cashInOutData);
            obj = tillEvent[0].cashInOutData;
          }

          payments = paymentMethodList.map((payment) => {
            let expectedAmount = 0,
              paymentReturn = 0,
              transactionCount = 0;
            orders.forEach(({ total, payments: orderPayments = [], paymentData = [], deliveryDate }) => {
              orderPayments.forEach(({ name, amount }) => {
                if (payment.name.toLowerCase() === name.toLowerCase()) {
                  const value = parseFloat(amount || 0);
                  total > 0 ? (expectedAmount += value) : (paymentReturn += Math.abs(value));
                  transactionCount++;
                }
              });
              if (deliveryDate) {
                const openingMoment = dayjs(tillSession.openingTime, "YYYY-MM-DD HH:mm:ss");
                const orderMoment = dayjs(deliveryDate, "DD-MM-YYYY HH:mm:ss");
                const now = dayjs();
                if ((orderMoment.isAfter(openingMoment) || orderMoment.isSame(openingMoment)) && (orderMoment.isBefore(now) || orderMoment.isSame(now))) {
                  paymentData.forEach(({ name, amount }) => {
                    if (payment.name.toLowerCase() === name.toLowerCase()) {
                      const value = parseFloat(amount || 0);
                      total > 0 ? (expectedAmount += value) : (paymentReturn += Math.abs(value));
                      transactionCount++;
                    }
                  });
                }
              }
            });
            tillEvent.forEach(({ walletTransactions = [] }) => {
              walletTransactions?.forEach((transaction) => {
                if (transaction?.finPaymentmethodID === payment?.finPaymentmethodId) {
                  const value = parseFloat(transaction?.amount || 0);
                  expectedAmount += value;
                  transactionCount++;
                }
              });
            });
            return { ...payment, expectedAmount, amount: 0, paymentReturn, difference: Math.abs(paymentReturn) - expectedAmount, transactionCount };
          });
        }

        if (posConfig?.showDenominations === "N") {
          const orders = await db.orders.where("tillSessionId").equals(sessionId).toArray();
          const openAmount = useSessionStore.getState().tillSession?.totalOpeningAmount;

          setTotalOrdersCount(orders.length);
          const updatedTillSession = { ...tillSession };
          const updatedAllPaymentsData = [...payments];
          const cashPaymentIndex = updatedAllPaymentsData.findIndex((payment) => payment.name.toLowerCase() === "cash");

          if (cashPaymentIndex !== -1) {
            updatedAllPaymentsData[cashPaymentIndex].amount = totalAmount;
            updatedAllPaymentsData[cashPaymentIndex].expectedAmount = parseFloat(updatedAllPaymentsData[cashPaymentIndex].expectedAmount.toFixed(2));
            updatedAllPaymentsData[cashPaymentIndex].cashSaleAmount = parseFloat(updatedAllPaymentsData[cashPaymentIndex].expectedAmount.toFixed(2));
            updatedAllPaymentsData[cashPaymentIndex].difference =
              parseFloat(updatedAllPaymentsData[cashPaymentIndex].amount) - parseFloat(updatedAllPaymentsData[cashPaymentIndex].expectedAmount);
            updatedAllPaymentsData[cashPaymentIndex].difference = parseFloat(updatedAllPaymentsData[cashPaymentIndex].difference.toFixed(2));
          }

          updatedTillSession.closingTime = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
          updatedTillSession.closingCash = totalAmount;
          updatedTillSession.closingCashDenominations = [];
          updatedTillSession.allPaymentsData = updatedAllPaymentsData;
          updatedTillSession.totalOrdersCount = orders.length;

          await db.tillEvents.where("tillSessionId").equals(updatedTillSession.tillSessionId).modify(updatedTillSession);
          useSessionStore.getState().setTillSession(updatedTillSession);

          setAllExpectedAmount(updatedAllPaymentsData[cashPaymentIndex]?.expectedAmount);
          setAllTransactionCount(updatedAllPaymentsData[cashPaymentIndex]?.transactionCount);
          setTotalAmount(updatedAllPaymentsData[cashPaymentIndex]?.amount);
          setTotalOrdersCount(orders.length);
          setPaymentsList([...payments]);
        } else if (posConfig?.showDenominations === "Y") {
          // const tillSessionPayments = tillSession?.allPaymentsData || [];

          const tillSessionPayments = (tillSession?.allPaymentsData || []).filter((payment) => !payment.cwrTillId || payment?.cwrTillId === tillId).map((p) => ({ ...p }));

          let totalAmountAllPayments = 0;
          let transactionCount = 0;
          let total = 0;
          let salesAmount = 0;

          tillSessionPayments.forEach((pay) => {
            totalAmountAllPayments += pay.expectedAmount;
            transactionCount += pay.transactionCount;
            if (pay.name.toLowerCase() === "cash") {
              salesAmount += pay?.cashSaleAmount - pay?.paymentReturn;
            } else {
              salesAmount += pay?.expectedAmount - pay?.paymentReturn;
            }
            pay.expectedAmount -= pay.paymentReturn;
          });

          const openAmount = useSessionStore.getState().tillSession?.totalOpeningAmount;

          setSalesAmount(salesAmount);

          payments.forEach((ele) => {
            if (ele.name.toLowerCase() === "cash") {
              ele.expectedAmount -= ele.paymentReturn;
            } else {
              ele.expectedAmount -= ele.paymentReturn;
              ele.amount = parseFloat((ele.amount - ele.paymentReturn).toFixed(2));
            }
            total += parseFloat(ele.amount);
          });

          totalAmountAllPayments = salesAmount + obj.cashIn - obj.cashOut + obj.pettyCashIn - obj.pettyCashOut + openAmount;

          useSessionStore.getState().setTillSession({ ...tillSession, allPaymentsData: payments });

          setAllExpectedAmount(totalAmountAllPayments);
          setAllTransactionCount(transactionCount);
          setTotalAmount(total);
          setTotalOrdersCount(tillSession.totalOrdersCount);
          setPaymentsList([...payments]);
        }
      } catch (error) {
        console.error("Error processing till data:", error);
      }
    };

    fetchTillData();
  }, []);

  const history = useHistory();

  useEffect(() => {
    trace("CloseTillAll", "guard check", {
      hasCsBunit: !!tillData?.tillAccess?.csBunit,
      hasTillSession: !!tillSession,
    });
    if (!tillData?.tillAccess?.csBunit || !tillSession) {
      trace("CloseTillAll", "guard FIRED → /till");
      history.replace("/till");
    }
  }, []);

  // Show the actual opening date, not the current system date
  const openingDate = tillSession?.openingTime ? new Date(tillSession.openingTime.replace(/-/g, "/")).toLocaleDateString() : new Date().toLocaleDateString();
  const [displayClock, setDisplayClock] = useState("");
  useEffect(() => {
    const run = async () => {
      setDisplayClock(clock());
    };
    run();
    const timerId = setInterval(() => setDisplayClock(clock()), 1000);
    return () => {
      clearInterval(timerId);
    };
  }, []);

  const confirmBtnRef = useRef(null);
  const cancelBtnRef = useRef(null);

  const onFieldInput = (e) => {
    const { name, value } = e.target;
    const updatedPaymentsList = paymentsList;
    const paymentIndex = updatedPaymentsList.findIndex((pi) => pi.name === name);
    updatedPaymentsList[paymentIndex].amount = parseFloat(value);
    updatedPaymentsList[paymentIndex].actualAmount = parseFloat(value);
    const diff = parseFloat(value) - parseFloat(updatedPaymentsList[paymentIndex].expectedAmount);
    updatedPaymentsList[paymentIndex].difference = isNaN(diff) ? 0 : diff;
    setPaymentsList([...updatedPaymentsList]);
    let totalAmountVal = 0;

    updatedPaymentsList.map((p) => {
      return (totalAmountVal += isNaN(parseFloat(p.amount)) ? 0 : parseFloat(p.amount));
    });

    db.paymentsData
      .where("tillStatus")
      .equalsIgnoreCase("open")
      .modify((event) => {
        event.payments = updatedPaymentsList;
      });
    db.tillEvents
      .where("tillSessionId")
      .equals(sessionId)
      .modify((event) => {
        event.allPaymentsData = updatedPaymentsList;
        event.allPaymentsData[paymentIndex].amount = parseFloat(value);
      });
    setTotalAmount(totalAmountVal);
  };

  const onFieldOut = (e) => {
    if (e.target.value === "") {
      const { name } = e.target;
      const value = 0;
      const updatedPaymentsList = paymentsList;
      const paymentIndex = updatedPaymentsList.findIndex((pi) => pi.name === name);
      updatedPaymentsList[paymentIndex].amount = value;
      const diff = parseFloat(value) - parseFloat(updatedPaymentsList[paymentIndex].expectedAmount);
      updatedPaymentsList[paymentIndex].difference = isNaN(diff) ? 0 : diff;
      setPaymentsList([...updatedPaymentsList]);
      let totalAmountVal = 0;
      updatedPaymentsList.map((p) => {
        return (totalAmountVal += isNaN(parseFloat(p.amount)) ? 0 : parseFloat(p.amount));
      });
      setTotalAmount(totalAmountVal);
    }
  };

  const checkFlag = () => {
    const paymentMismatches = [];
    const zeroAmountErrors = [];
    paymentsList.forEach((res) => {
      let expected;
      const actual = isNaN(parseFloat(res.amount)) ? 0 : parseFloat(res.amount.toFixed(2));
      // console.debug(`Payment: ${res.name}, Raw Expected: ${res.expectedAmount}, Raw Actual: ${res.amount}`);

      if (posConfig?.cashDiffInShiftClose === "N" && res.name.toLowerCase() === "cash") {
        const expectedAmount = isNaN(parseFloat(res.expectedAmount)) ? 0 : parseFloat(res.expectedAmount);
        const integerPart = Math.floor(expectedAmount);
        const decimalPart = expectedAmount - integerPart;
        let roundedDecimal;
        if (decimalPart <= 0.25 && decimalPart > 0) {
          roundedDecimal = 0.25;
        } else if (decimalPart <= 0.5 && decimalPart > 0) {
          roundedDecimal = 0.5;
        } else if (decimalPart <= 0.75 && decimalPart > 0) {
          roundedDecimal = 0.75;
        } else if (decimalPart > 0) {
          roundedDecimal = 1.0;
        } else {
          roundedDecimal = 0;
        }
        expected = parseFloat((integerPart + roundedDecimal).toFixed(2));
        // console.debug(`Payment: ${res.name}, Expected: ${expected}, Actual: ${actual}`);
        const roundedValue = integerPart + roundedDecimal;

        const difference = res.name.toLowerCase() === "cash" ? roundedValue - res.amount : res.expectedAmount.toFixed(2) - res.amount;

        if (parseFloat(difference) !== 0) {
          paymentMismatches.push({
            paymentMethod: res.name,
            difference: difference,
          });
        }
      } else {
        expected = isNaN(parseFloat(res.expectedAmount)) ? 0 : parseFloat(res.expectedAmount.toFixed(2));
      }

      if (expected > 0 && actual === 0) {
        zeroAmountErrors.push({
          paymentMethod: res.name,
        });
      }
    });

    if (zeroAmountErrors.length > 0) {
      message.error(`${messages.errors.till_management.actual_amount_required}`);
    } else if (paymentMismatches.length > 0) {
      message.error(
        `${messages.errors.till_management.amount_mismatch} ${paymentMismatches
          .map((mismatch) => `${mismatch.paymentMethod}: ${parseFloat(mismatch.difference).toFixed(2)}`)
          .join(", ")}.`
      );
    } else {
      history.push("/cash-to-keep");
    }
  };
  let reconstructedObject;

  const rawtillAccessMeta = tillData?.tillAccess?.tillAccessMeta;
  if (rawtillAccessMeta) {
    const rawDataArray = tillData?.tillAccess?.tillAccessMeta;

    // Find the object with the key "Open Till"
    const closeTillObject = rawDataArray.find((item) => item.key === "Close Till");

    // Access the value property of the found object
    const closeTillValue = closeTillObject?.value;

    if (closeTillValue !== undefined) {
      // The rest of your code that depends on closeTillValue
      // Clean up the string (remove extra characters)
      const cleanedData = closeTillValue.replace(/[{}"]/g, "");

      // Split the string into key-value pairs
      const keyValuePairs = cleanedData.split(",");

      // Create an object from key-value pairs
      reconstructedObject = {};
      keyValuePairs.forEach((pair) => {
        if (pair.includes(":")) {
          const [key, value] = pair.split(":");
          if (key !== undefined && value !== undefined) {
            reconstructedObject[key.trim()] = value.trim();
          }
        }
      });
    } else {
      console.error("closeTillValue is undefined");
    }
  }

  const spanValue =
    reconstructedObject === undefined
      ? 4 // Default value when reconstructedObject is undefined
      : posConfig?.cashDiffInShiftClose === "Y" && reconstructedObject?.ExpectedAmount === "Y" && reconstructedObject?.Difference === "Y"
        ? 4 // All flags are "Y"
        : posConfig?.cashDiffInShiftClose === "Y" && reconstructedObject?.ExpectedAmount === "Y" && reconstructedObject?.Difference === "N"
          ? 6 // cashDiffInShiftClose and ExpectedAmount are "Y", Difference is null
          : posConfig?.cashDiffInShiftClose === "Y" && reconstructedObject?.ExpectedAmount === "N" && reconstructedObject?.Difference === "Y"
            ? 6 // cashDiffInShiftClose is "Y", ExpectedAmount is null, Difference is not null
            : posConfig?.cashDiffInShiftClose === "Y" && reconstructedObject?.ExpectedAmount === "N" && reconstructedObject?.Difference === "N"
              ? 8 // cashDiffInShiftClose is "Y", ExpectedAmount and Difference are null
              : posConfig?.cashDiffInShiftClose !== "Y" && reconstructedObject?.ExpectedAmount === "Y"
                ? 6 // cashDiffInShiftClose is not "Y", ExpectedAmount and Difference are not null
                : posConfig?.cashDiffInShiftClose !== "Y" && reconstructedObject?.ExpectedAmount === "N"
                  ? 6 // cashDiffInShiftClose is not "Y", ExpectedAmount is null, Difference is not null
                  : 4;

  if (!tillData?.tillAccess?.csBunit || !tillSession) {
    return null;
  }

  return (
    <div className="till-screen">
      <header className="till-header">
        <img src={MenuIcon} className="till-header__logo" alt="" />
        <span className="till-header__title">{getMultilingualText("Close Till")}</span>
      </header>
      <div className="till-stepper">
        <div className="till-stepper__step till-stepper__step--completed">
          <span className="till-stepper__circle">&#10003;</span>
          <span className="till-stepper__label">{getMultilingualText("Count Cash")}</span>
        </div>
        <div className="till-stepper__connector till-stepper__connector--completed"></div>
        <div className="till-stepper__step till-stepper__step--active">
          <span className="till-stepper__circle">2</span>
          <span className="till-stepper__label">{getMultilingualText("Reconcile")}</span>
        </div>
        <div className="till-stepper__connector"></div>
        <div className="till-stepper__step">
          <span className="till-stepper__circle">3</span>
          <span className="till-stepper__label">{getMultilingualText("Close")}</span>
        </div>
      </div>
      <div className="till-panel">
        <div className="till-panel__main--wide">
          <div className="till-card">
            <Row
              style={{
                padding: "1% 0%",
                borderBottom: "1px solid rgba(0, 0, 0, 0.09)",
                fontSize: "1vw",
              }}
            >
              <Col span={spanValue} className="till-card__header-col">
                <span>Payment Name</span>
                {multilingual && <span style={{ display: "block" }}>{t("Payment Name")}</span>}
              </Col>
              <Col span={spanValue} className="till-card__header-col">
                <span>Transactions</span>
                {multilingual && <span style={{ display: "block" }}>{t("Transactions")}</span>}
              </Col>
              <Col
                span={spanValue}
                className="till-card__header-col"
                style={{
                  display: !reconstructedObject || reconstructedObject?.ExpectedAmount === "Y" ? "block" : "none",
                }}
              >
                <span>Expected Amount</span>
                {multilingual && <span style={{ display: "block" }}>{t("Expected Amount")}</span>}
              </Col>
              <Col span={spanValue} className="till-card__header-col">
                <span>Actual Amount</span>
                {multilingual && <span style={{ display: "block" }}>{t("Actual Amount")}</span>}
              </Col>
              {posConfig?.cashDiffInShiftClose === "Y" ? (
                <Col
                  span={spanValue}
                  className="till-card__header-col"
                  style={{
                    display: !reconstructedObject || reconstructedObject?.Difference === "Y" ? "block" : "none",
                  }}
                >
                  <span>Difference</span>
                </Col>
              ) : null}
            </Row>
            <div className="till-card__body">
              <Scrollbars className="closeTillScroll">
                {paymentsList
                  .filter((payment) => !payment.cwrTillId || payment.cwrTillId === tillId)
                  .map((payment, index) => (
                    <Row className="till-payment-table__row" key={payment.name}>
                      <Col span={spanValue} className="till-payment-table__cell till-payment-table__cell--name">
                        {reconstructedObject?.[payment.name.replace(/\s/g, "")] === "Y" ? (
                          <EditOutlined
                            style={{
                              marginBottom: "1rem",
                              position: "relative",
                              left: "-1.5vw",
                            }}
                          />
                        ) : null}
                        <p className="till-payment-table__cell-text">{payment.name}</p>
                      </Col>

                      <Col span={spanValue} className="till-payment-table__cell">
                        <p className="till-payment-table__cell-text">{payment.transactionCount}</p>
                      </Col>
                      {!reconstructedObject || reconstructedObject?.ExpectedAmount === "Y" ? (
                        <Col span={spanValue} className="till-payment-table__cell" style={{ paddingRight: "4vw", paddingBottom: "1.5vh" }}>
                          <Input
                            name={`${payment.name}`}
                            value={parseFloat(payment.expectedAmount) > 0 ? parseFloat(payment.expectedAmount).toFixed(2) : 0}
                            readOnly={true}
                            className="till-payment-table__input--readonly"
                          />
                        </Col>
                      ) : null}

                      <Col span={spanValue} className="till-payment-table__cell" style={{ paddingRight: "4vw", marginBottom: "1.1vh" }}>
                        {reconstructedObject?.[payment.name.replace(/\s/g, "")] === "Y" ? (
                          // Config says "Y" for this payment — show edit icon + click-to-edit toggle
                          editAmount === payment.name ? (
                            <Input
                              name={`${payment.name}`}
                              value={payment.amount}
                              type="number"
                              onChange={onFieldInput}
                              onBlur={onFieldOut}
                              readOnly={false}
                              className="till-payment-table__input--editable"
                            />
                          ) : (
                            <Button
                              onClick={() => {
                                setEditAmount(payment.name);
                              }}
                              className="till-payment-table__edit-btn"
                            >
                              {payment.amount}
                            </Button>
                          )
                        ) : !reconstructedObject ? (
                          // No config defined — all payments editable by default
                          <Input
                            name={`${payment.name}`}
                            value={payment.amount}
                            type="number"
                            onChange={onFieldInput}
                            onBlur={onFieldOut}
                            readOnly={false}
                            className="till-payment-table__input--editable"
                          />
                        ) : (
                          // Config exists but this payment is not "Y" — readOnly
                          <Input name={`${payment.name}`} value={payment.amount} type="number" readOnly={true} className="till-payment-table__input--readonly" />
                        )}
                      </Col>
                      {posConfig?.cashDiffInShiftClose === "Y" ? (
                        <Col
                          span={spanValue}
                          className="till-payment-table__cell"
                          style={{ display: !reconstructedObject || reconstructedObject?.Difference === "Y" ? "block" : "none" }}
                        >
                          <p className="till-payment-table__cell-text">{parseFloat(payment.difference).toFixed(2)}</p>
                        </Col>
                      ) : null}
                    </Row>
                  ))}
              </Scrollbars>
            </div>
          </div>
        </div>
        <div className="till-panel__sidebar">
          <div className="till-card--sidebar">
            <p className="till-summary__opened-on">{getMultilingualText("Opened On")}</p>
            <div className="till-summary__datetime">
              <span>{openingDate}</span>
              <span>{displayClock}</span>
            </div>
            <Form>
              <Scrollbars className="closeTillScroll1" style={{ height: "10vh" }}>
                <p className="till-summary__section-title--lg">{getMultilingualText("Transactions")}</p>
                <Form.Item style={{ marginBottom: "0.8vh" }}>
                  <p className="till-summary__field-label">{getMultilingualText("Payment Transactions")}</p>
                  <Input type="number" value={allTransactionCount} readOnly={true} className="transactionAmtInputClose" style={{ height: "5.5vh", marginTop: "1vh" }} />
                </Form.Item>
                <Form.Item style={{ marginBottom: "0.8vh" }}>
                  <p className="till-summary__field-label">{getMultilingualText("Retail Transactions")}</p>
                  <Input value={totalOrdersCount} readOnly={true} className="transactionAmtInputClose" style={{ height: "5.5vh", marginTop: "1vh" }} />
                </Form.Item>

                <Form.Item
                  style={{
                    marginBottom: "0.8vh",
                    display: reconstructedObject ? (reconstructedObject.OpeningAmount === "Y" ? "block" : "none") : "block",
                  }}
                >
                  <p className="till-summary__field-label">{getMultilingualText("Opening Amount")}</p>
                  <Input
                    value={`${parseFloat(useSessionStore.getState().tillSession?.totalOpeningAmount || 0).toFixed(2)}`}
                    readOnly={true}
                    className="transactionAmtInputClose"
                    style={{ height: "5.5vh", marginTop: "1vh" }}
                  />
                </Form.Item>
                <Form.Item style={{ marginBottom: "0.8vh" }}>
                  <p className="till-summary__field-label">{getMultilingualText("Notes")}</p>
                  <Input onChange={(e) => setNoteValue(e.target.value)} className="transactionAmtInputClose" style={{ height: "5.5vh", marginTop: "1vh" }} />
                </Form.Item>
                <Form.Item
                  style={{
                    marginBottom: "0.8vh",
                    display: reconstructedObject ? (reconstructedObject.SalesAmount === "Y" ? "block" : "none") : "block",
                  }}
                >
                  <p className="till-summary__field-label">{getMultilingualText("Sales Amount")}</p>
                  <Input value={`${parseFloat(salesAmount ?? 0).toFixed(2)}`} readOnly={true} className="transactionAmtInputClose" style={{ height: "5.5vh", marginTop: "1vh" }} />
                </Form.Item>

                <Form.Item
                  style={{
                    marginBottom: "0.8vh",
                    display: reconstructedObject ? (reconstructedObject.CashIn === "Y" ? "block" : "none") : "block",
                  }}
                >
                  <p className="till-summary__field-label">{getMultilingualText("Cash In")}</p>
                  <Input value={`${parseFloat(cashValues.cashIn).toFixed(2)}`} readOnly={true} className="transactionAmtInputClose" style={{ height: "5.5vh", marginTop: "1vh" }} />
                </Form.Item>
                <Form.Item
                  style={{
                    marginBottom: "0.8vh",
                    display: reconstructedObject ? (reconstructedObject.CashOut === "Y" ? "block" : "none") : "block",
                  }}
                >
                  <p className="till-summary__field-label">{getMultilingualText("Cash Out")}</p>
                  <Input
                    value={`${parseFloat(cashValues.cashOut).toFixed(2)}`}
                    readOnly={true}
                    className="transactionAmtInputClose"
                    style={{ height: "5.5vh", marginTop: "1vh" }}
                  />
                </Form.Item>
                <Form.Item
                  style={{
                    marginBottom: "0.8vh",
                    display: reconstructedObject ? (reconstructedObject.PettyCashIn === "Y" ? "block" : "none") : "block",
                  }}
                >
                  <p className="till-summary__field-label">{getMultilingualText("Petty Cash In")}</p>
                  <Input value={`${parseFloat(cashValues.pettyCashIn).toFixed(2)}`} readOnly={true} className="transactionAmtInputClose" style={{ height: "4.5vh" }} />
                </Form.Item>
                <Form.Item
                  style={{
                    marginBottom: "0.8vh",
                    display: reconstructedObject ? (reconstructedObject.PettyCashOut === "Y" ? "block" : "none") : "block",
                  }}
                >
                  <p className="till-summary__field-label">{getMultilingualText("Petty Cash Out")}</p>
                  <Input value={`${parseFloat(cashValues.pettyCashOut).toFixed(2)}`} readOnly={true} className="transactionAmtInputClose" style={{ height: "4.5vh" }} />
                </Form.Item>
                <Form.Item
                  style={{
                    marginBottom: "0.8vh",
                    display: reconstructedObject ? (reconstructedObject.ExpectedAmount === "Y" ? "block" : "none") : "block",
                  }}
                >
                  <p className="till-summary__field-label">{getMultilingualText("Expected Amount")}</p>
                  <Input
                    value={`${parseFloat(allExpectedAmount) >= 0 ? parseFloat(allExpectedAmount).toFixed(2) : 0.0}`}
                    readOnly={true}
                    className="transactionAmtInputClose"
                    style={{ height: "5.5vh", marginTop: "1vh" }}
                  />
                </Form.Item>
                <Form.Item style={{ marginBottom: "0.8vh" }}>
                  <p className="till-summary__field-label">{getMultilingualText("Total Amount")}</p>
                  <Input value={`${parseFloat(totalAmount).toFixed(2)}`} readOnly={true} className="transactionAmtInputClose" style={{ height: "5.5vh", marginTop: "1vh" }} />
                </Form.Item>
              </Scrollbars>
            </Form>
            <div className="till-actions" style={{ paddingTop: "3.5vh" }}>
              <Button ref={cancelBtnRef} className="till-btn--secondary">
                {hideBackButton ? (
                  <Link to={"/till"}>{getMultilingualText("Back")}</Link>
                ) : (
                  <Link to={posConfig?.showDenominations === "Y" && paymentsList.some((payment) => payment.name.toLowerCase() === "cash") ? "/close-till" : "/pos"}>
                    {getMultilingualText("Back")}
                  </Link>
                )}
              </Button>
              <Button ref={confirmBtnRef} className="till-btn--primary" onClick={checkFlag}>
                {getMultilingualText("Next")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloseTillAll;
